"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOverSIOCDimsLimit = exports.SIOC_DIMENSIONS_LIMITS = exports.areDimValuesTrusted = exports.isDimValueValid = exports.areDimValuesPopulated = exports.areDimensionsValid = exports.trustedDimSourceTypes = exports.dimSourceTypeNumericRanking = exports.dimSourceTypeRanking = void 0;
exports.dimSourceTypeRanking = [
    "listingtool",
    "amazoncostcalc",
    "seller",
    "warehouse",
    "amazonscraped",
    "crossdock",
    "fc-dims-and-weight",
    "averageregression",
    "manual",
];
exports.dimSourceTypeNumericRanking = {
    listingtool: 100,
    amazoncostcalc: 110,
    seller: 120,
    warehouse: 130,
    amazonscraped: 140,
    crossdock: 150,
    averageregression: 170,
    manual: 180,
    "fc-dims-and-weight": 180,
};
exports.trustedDimSourceTypes = [
    "amazonscraped",
    "averageregression",
    "crossdock",
    "fc-dims-and-weight",
    "manual",
    "warehouse",
    "seller",
];
const areDimensionsValid = (productDimensions) => {
    return (0, exports.areDimValuesPopulated)(productDimensions) && (0, exports.areDimValuesTrusted)(productDimensions);
};
exports.areDimensionsValid = areDimensionsValid;
const areDimValuesPopulated = (productDimensions) => {
    return [productDimensions.length, productDimensions.width, productDimensions.height, productDimensions.weight].every(exports.isDimValueValid);
};
exports.areDimValuesPopulated = areDimValuesPopulated;
const isDimValueValid = (value) => {
    return Boolean(value && value >= 0.001);
};
exports.isDimValueValid = isDimValueValid;
const areDimValuesTrusted = (productDimensions) => {
    return !productDimensions.dimSourceType
        ? false
        : exports.trustedDimSourceTypes.includes(productDimensions.dimSourceType);
};
exports.areDimValuesTrusted = areDimValuesTrusted;
exports.SIOC_DIMENSIONS_LIMITS = {
    WEIGHT: 20,
    LONGEST_MEASUREMENT: 18,
    MIDDLE_MEASUREMENT: 14,
    SHORTEST_MEASUREMENT: 8,
};
function isOverSIOCDimsLimit(product) {
    const { length, width, height, weight } = product;
    let sortedDims = [];
    if (length && width && height) {
        sortedDims = [length, width, height].sort((n1, n2) => n1 - n2);
    }
    if ((weight && weight > exports.SIOC_DIMENSIONS_LIMITS.WEIGHT) ||
        (sortedDims[0] && sortedDims[0] > exports.SIOC_DIMENSIONS_LIMITS.SHORTEST_MEASUREMENT) ||
        (sortedDims[1] && sortedDims[1] > exports.SIOC_DIMENSIONS_LIMITS.MIDDLE_MEASUREMENT) ||
        (sortedDims[2] && sortedDims[2] > exports.SIOC_DIMENSIONS_LIMITS.LONGEST_MEASUREMENT)) {
        return true;
    }
    return false;
}
exports.isOverSIOCDimsLimit = isOverSIOCDimsLimit;
//# sourceMappingURL=ProductDimensionUtils.js.map